import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IAuthData } from '../../initialState';

export interface ISetTokenAction {
  accessToken: string;
}

function setToken(
  draft: Draft<IAuthData>,
  action: PayloadAction<ISetTokenAction>,
) {
  draft.authorization.accessToken = action.payload.accessToken;
}

export default setToken;
